import React from "react";
import ApplicationPageProps from "core/models/ApplicationPageProps";
import { Redirect } from "react-router-dom";

export default function AdminPage (props:ApplicationPageProps): JSX.Element{
  return <Redirect to="/applications/admin/role-update"/>;  
}